import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from "moment";
import Sidemenu from '../../components/sidemenu';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Pagination from '../../components/pagination';
import Confirmation from '../../components/confirmation';
import InputSuggestion from '../../components/elements/inputSuggestion01';
import Dropdown from '../../components/elements/dropdown01';
import MoreDropDown from '../../components/elements/moreDropDown02';
import * as Styled from './styled';

import { contestRequest, draftRequest } from './actions';
import { locationRequest, skillRequest, locationClear, skillClear } from '../addContest/actions';

class ContestPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      page: 1,
      entries: 10,
      activeStatus: 'All',
      locationTypeList: [
        { id: 'Onsite', title: 'Onsite' },
        { id: 'Remote', title: 'Remote' },
        { id: 'Hybrid', title: 'Hybrid' },
      ],
      jobTypeList: [
        { id: 'Contract', title: 'Contract' },
        { id: 'Internship', title: 'Internship' },
        { id: 'Fulltime', title: 'Fulltime' },
        { id: 'Part time', title: 'Part time' },
        { id: 'Freelance', title: 'Freelance' },
      ],
      status: [
        { name: 'All Jobs', value: 'All' },
        { name: 'Active', value: 'ONGOING' },
        { name: 'Upcoming', value: 'UPCOMING' },
        { name: 'Draft', value: 'DRAFT' },
        { name: 'Expired', value: 'EXPIRED' },
      ],
      moreList: [
        {title: 'View'},
        {title: 'Edit'},
        {title: 'Draft/Publish'}
      ],
      activeLayout: 'list',
      filters: {},
    }
  }

  UNSAFE_componentWillMount() {
    this.props.contestRequest();
    this.props.locationRequest();
    this.props.skillRequest();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps
    && nextProps.contest
    && nextProps.contest.draft
    && nextProps.contest.draft.meta
    && nextProps.contest.draft.meta.code === 200
    && nextProps.contest.draft.meta.success === true) {
      nextProps.contestRequest(this.changeObject(this.state.filters));
    }
  }

  paginationClick = (page) => {
    this.setState({ page })
  }

  filterSelect = (id, name) => {
    const filters = this.state.filters;
    if (typeof id !== 'undefined' && id !== null && id !== '') {
      filters[name] = id;
    } else {
      delete filters[name];
    }
    this.props.contestRequest(this.changeObject(filters));
    this.setState({ filters });
  }

  changeObject = (obj) => {
    const keys = Object.keys(obj);
    var n = keys.length;
    var newobj={}
    while (n--) {
      let key = keys[n];
      newobj[key.replace(/_/g, '')] = obj[key].toString().toUpperCase();
    }
    if (newobj.skillslist) {
      newobj.skill = newobj.skillslist;
      delete newobj.skillslist;
    }
    if (newobj.joblocationlist) {
      newobj.location = newobj.joblocationlist;
      delete newobj.joblocationlist;
    }
    return newobj;
  }

  closeConfirmation = () => {
    this.setState({ confirmation: false });
  }

  confirmDelete = () => {
    const id = this.state.id;
    this.props.deleteRequest(id, this.state.filters);
    this.setState({ confirmation: false, id: '' })
  }

  autoCompleteChange = (name, value) => {
    if (value === '') {
      this.autoCompleteSelect(name, '');
    } else {
      if (name === 'job_location_list') {
        this.props.locationRequest(value);
      } else if (name === 'skills_list') {
        this.props.skillRequest(value);
      }
    }
  }

  autoCompleteSelect = (name, value) => {
    if (typeof value !== 'undefined' && value !== null) {
      const filters = this.state.filters;
      filters[name] = [];
      filters[name].push(value);
      this.props.contestRequest(this.changeObject(filters));
      this.setState({ filters });
      if (name === 'job_location_list') {
        this.props.locationClear();
      } else if (name === 'skills_list') {
        this.props.skillClear();
      }
    }
  }

  getTag = (tag) => {
    switch (tag) {
      case 'ONGOING':
        return {
          color: '#21C17A',
          backgroundColor: 'rgba(33, 193, 122, 0.1)',
          border: '1px solid #21C17A'
        }
      case 'UPCOMING':
        return {
          color: '#939599',
          backgroundColor: 'rgba(147, 149, 153, 0.1)',
          border: '1px solid #939599'
        }
      case 'DRAFT':
        return {
          color: '#FFA91B',
          backgroundColor: 'rgba(255, 169, 27, 0.1)',
          border: '1px solid #FFA91B'
        }
      case 'EXPIRED':
        return {
          color: '#F1543F',
          backgroundColor: 'rgba(241, 84, 63, 0.1)',
          border: '1px solid #F1543F'
        }
        default:
          break;
    }
  }

  changeStatus = (activeStatus) => {
    this.setState({ activeStatus });
  }

  actionClick = (item, id, isActive) => {
    if (item === 'Draft/Publish') {
      this.props.draftRequest(id, !isActive);
    }
  }

  changeLayout = (activeLayout) => {
    this.setState({ activeLayout });
  }

  render () {
    const { page, entries, filters, confirmation, confirmationHeading, confirmationType, locationTypeList, jobTypeList, activeStatus, status, moreList, activeLayout } = this.state;
    const { contests, contestLoading } = this.props.contest;
    const { locations, skills } = this.props.addContest;
    
    return (
      <Styled.MainDiv>
        <Confirmation show={confirmation} heading={confirmationHeading} type={confirmationType} close={this.closeConfirmation} confirm={this.confirmDelete} buttonText="Delete" />
        <Sidemenu collapsed={this.state.sideMenuCollapsed} />
        <Styled.ColumnDiv>
          <Header />

          <Styled.ContentWrapDiv>
            <Styled.ContentDiv>
              <Styled.HeaderWrapDiv>
                <div>All Contests Plus</div>
                <div style={{display: "flex", alignItems: "center", justifyContent: "space-betweeen"}}>
                  <Styled.AddLink to="/contest-plus/new"><span>+</span>Add Contest Plus</Styled.AddLink>
                </div>
              </Styled.HeaderWrapDiv>

              <Styled.StatusWrapDiv>
                { status.map(s => (
                  <Styled.StatusButton active={activeStatus === s.value} onClick={() => this.changeStatus(s.value)}>{s.name}</Styled.StatusButton>
                )) }
              </Styled.StatusWrapDiv>

              <div style={{ minHeight: '58px', display: 'flex', justifyContent: 'space-between' }}>
                <Styled.FilterWrapDiv>
                  <InputSuggestion placeholder="Location" list={(locations && locations.locationsList) || []} value="id" name="job_location_list" selected={this.autoCompleteSelect} change={this.autoCompleteChange} width="142px" height="38px" option="city_name" active={filters.job_location_list} showLast />
                  <InputSuggestion placeholder="Skill" list={(skills && skills.skillsList) || []} value="id" name="skills_list" selected={this.autoCompleteSelect} change={this.autoCompleteChange} width="142px" height="38px" option="name" active={filters.skills_list} showLast />
                  <Dropdown title="Location Type" list={locationTypeList} value="id" name="location_type" selected={this.filterSelect} width="142px" option="title" active={filters} addAll />
                  <Dropdown title="Job Type" list={jobTypeList} value="id" name="job_type" selected={this.filterSelect} width="142px" option="title" active={filters} addAll />
                </Styled.FilterWrapDiv>

                {/* <Styled.LayoutWrapDiv>
                  <Styled.Layout01Button active={activeLayout === 'list'} onClick={() => this.changeLayout('list')} />
                  <Styled.Layout02Button active={activeLayout === 'grid'} onClick={() => this.changeLayout('grid')}>
                    <div /><div />
                  </Styled.Layout02Button>
                </Styled.LayoutWrapDiv> */}
              </div>

              <Styled.CardDiv layout={this.state.activeLayout}>
                { contests && contests.contestData && contests.contestData.length > 0 && contests.contestData.map((contest, contestIndex) => (
                  activeStatus === 'All' || activeStatus === contest.status ?
                    <Styled.ContestWrapDiv layout={this.state.activeLayout} index={contestIndex}>
                      <Styled.ContestLeftDiv>
                        <Styled.ContestHeadDiv>
                          {contest.job_title}
                          <Styled.TagSpan tagStyle={this.getTag(contest.status)}>{contest.status}</Styled.TagSpan>
                        </Styled.ContestHeadDiv>
                        <Styled.ContestDetailsP>
                          <span>{contest.company_name}</span>
                          { contest.job_location_list && contest.job_location_list.length > 1 ?
                            <span>
                              <span>Multiple Locations</span>
                              <Styled.TooltipSpan style={{ marginRight: '6px' }} >
                                <img src="/info-icon-round.svg" alt="locations" />
                                <div>
                                  { contest.job_location_list.map(l => (
                                    <div>{l}</div>
                                  )) }
                                </div>
                              </Styled.TooltipSpan>
                            </span>
                          :
                            <span>{contest.job_location_list[0] ? contest.job_location_list[0] : ''}</span>
                          }

                          {/* <span>{`${contest.applied} People Applied`}</span> */}
                          <span>{`${contest.total_questions} Questions`}</span>
                          <span>{`${contest.test_duration} Minutes`}</span>
                        </Styled.ContestDetailsP>
                        <Styled.ContestTimeDiv>
                          { contest.contest_start_date ?
                            <div>{`Starting on ${moment(contest.contest_start_date).format("Do MMM YYYY")}`}</div>
                          : ''
                          }
                          <div>{`Ending on ${moment(contest.contest_end_date).format("Do MMM YYYY")}`}</div>
                        </Styled.ContestTimeDiv>
                      </Styled.ContestLeftDiv>

                      <Styled.ContestRightDiv>
                        <MoreDropDown list={moreList} option="title" width="140px" selected={this.actionClick} id={contest.id} funnel_id={contest.funnel_id} isActive={contest.is_active} />
                      </Styled.ContestRightDiv>
                    </Styled.ContestWrapDiv>
                  : <></>
                )) }
              </Styled.CardDiv>

              { contests && contests.contestData && contests.contestData.length > 10 ?
                <Styled.PaginationWrapDiv>
                  <div style={{ fontSize: '14px' }}>Pages</div>
                  <Pagination
                    count={contests.contestData.length}
                    entries={entries}
                    currentPage={page}
                    paginationClick={this.paginationClick}
                  />
                </Styled.PaginationWrapDiv>
              : ''
              }

            </Styled.ContentDiv>

            <Footer />
          </Styled.ContentWrapDiv>

        </Styled.ColumnDiv>
      </Styled.MainDiv>
    )
  }
}

const mapStateToProps = state => ({
  contest: state.contest,
  addContest: state.addContest,
})

const mapDispatchToProps = {
  contestRequest,
  locationRequest,
  skillRequest,
  locationClear,
  skillClear,
  draftRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(ContestPage)
